module.exports = __webpack_public_path__ + "img/hopways-03.28054dfa.webp";